import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AltaExpressForm } from "@/components/AltaExpressForm";
import { toast } from "sonner";
import { Zap } from "lucide-react";

/** Alta express desde la vista del profesor, siempre en la sede de la clase abierta. */
export const AltaExpressProfesor = ({ sedeId, claseSugerida, onCreado }) => {
  const [open, setOpen] = useState(false);
  const [clases, setClases] = useState([]);
  const [planes, setPlanes] = useState([]);

  useEffect(() => {
    if (!open) return;
    api.get("/clases").then(({ data }) => setClases(data.filter((c) => !sedeId || c.sede_id === sedeId)))
      .catch(() => setClases([]));
    api.get("/planes").then(({ data }) => setPlanes(data.filter((p) => !sedeId || p.sede_id === sedeId)))
      .catch(() => setPlanes([]));
  }, [open, sedeId]);

  const enviar = async (form) => {
    try {
      const { data } = await api.post("/alumnos/alta-express", { ...form, sede_id: sedeId });
      toast.success(`Alumno dado de alta · matrícula ${data.matricula}`);
      setOpen(false);
      onCreado?.();
      return true;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail), { duration: 9000 });
      return false;
    }
  };

  return (
    <>
      <Button variant="outline" className="rounded-full font-semibold mt-3 w-full"
        onClick={() => setOpen(true)} data-testid="alta-express-profesor-btn">
        <Zap className="h-4 w-4 mr-2" /> Alta express de un alumno nuevo
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-2xl max-w-2xl max-h-[85vh] overflow-y-auto"
          data-testid="alta-express-profesor-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Alta express</DialogTitle>
          </DialogHeader>
          <p className="text-xs text-muted-foreground">
            Se dará de alta en tu sede. Después puedes añadirlo a la clase de hoy desde
            «¿No está en la lista?».
          </p>
          <AltaExpressForm clases={clases}
            planes={planes} onEnviar={(f) => enviar({ ...f, clase_id: f.clase_id || claseSugerida })} />
        </DialogContent>
      </Dialog>
    </>
  );
};
